import isEmpty from 'lodash/isEmpty';

import { VARIANTS } from '@jobcase/react_pattern_library/components/Toaster/Toaster';

import { setNotification } from '../../notification/actions';
import { getProfileKey } from '../../authentication/selectors';
import { setOrgAssociation } from '../../utils/actions';
// eslint-disable-next-line import/no-cycle
import { loadEmployerAccount } from '../employers/actions';

import entity from './entity';
import { merge } from '../../../../utils/state';
import JobsAPI from '../../../../utils/api/jobsAPI';

export const TYPES = {
  ...entity.TYPES,
  GET_ORG_REQUEST: 'subOrganizations/GET_ORG_REQUEST',
  GET_ORG_SUCCESS: 'subOrganizations/GET_ORG_SUCCESS',
  GET_ORG_FAILURE: 'subOrganizations/GET_ORG_FAILURE',
  GET_ORG_ADMIN_DETAILS_REQUEST: 'settings/GET_ORG_ADMIN_DETAILS_REQUEST',
  GET_ORG_ADMIN_DETAILS_SUCCESS: 'settings/GET_ORG_ADMIN_DETAILS_SUCCESS',
  GET_ORG_ADMIN_DETAILS_ERROR: 'settings/GET_ORG_ADMIN_DETAILS_ERROR',
  EDIT_ORG_ADMIN_DETAILS_REQUEST: 'settings/EDIT_ORG_ADMIN_DETAILS_REQUEST',
  EDIT_ORG_ADMIN_DETAILS_SUCCESS: 'settings/EDIT_ORG_ADMIN_DETAILS_SUCCESS',
  EDIT_ORG_ADMIN_DETAILS_ERROR: 'settings/EDIT_ORG_ADMIN_DETAILS_ERROR',
  GET_ORG_ASSETS_DETAILS_REQUEST: 'settings/GET_ORG_ASSETS_DETAILS_REQUEST',
  GET_ORG_ASSETS_DETAILS_SUCCESS: 'settings/GET_ORG_ASSETS_DETAILS_SUCCESS',
  GET_ORG_ASSETS_DETAILS_ERROR: 'settings/GET_ORG_ASSETS_DETAILS_ERROR',
  CREATE_ORG_ASSETS_REQUEST: 'settings/CREATE_ORG_ASSETS_REQUEST',
  CREATE_ORG_ASSETS_SUCCESS: 'settings/CREATE_ORG_ASSETS_SUCCESS',
  CREATE_ORG_ASSETS_ERROR: 'settings/CREATE_ORG_ASSETS_ERROR',
  EDIT_ORG_ASSETS_REQUEST: 'settings/EDIT_ORG_ASSETS_REQUEST',
  EDIT_ORG_ASSETS_SUCCESS: 'settings/EDIT_ORG_ASSETS_SUCCESS',
  EDIT_ORG_ASSETS_ERROR: 'settings/EDIT_ORG_ASSETS_ERROR',
  DELETE_ORG_ASSETS_REQUEST: 'settings/DELETE_ORG_ASSETS_REQUEST',
  DELETE_ORG_ASSETS_SUCCESS: 'settings/DELETE_ORG_ASSETS_SUCCESS',
  DELETE_ORG_ASSETS_ERROR: 'settings/DELETE_ORG_ASSETS_ERROR',
  EDIT_ORG_DETAILS_REQUEST: 'settings/EDIT_ORG_DETAILS_REQUEST',
  EDIT_ORG_DETAILS_SUCCESS: 'settings/EDIT_ORG_DETAILS_SUCCESS',
  EDIT_ORG_DETAILS_ERROR: 'settings/EDIT_ORG_DETAILS_ERROR',
  GET_ORG_ADMIN_DOCUMENT_REQUEST: 'settings/GET_ORG_ADMIN_DOCUMENT_REQUEST',
  GET_ORG_ADMIN_DOCUMENT_SUCCESS: 'settings/GET_ORG_ADMIN_DOCUMENT_SUCCESS',
  GET_ORG_ADMIN_DOCUMENT_ERROR: 'settings/GET_ORG_ADMIN_DOCUMENT_ERROR',
  CLEAR_ORG_ADMIN_DOCUMENT: 'settings/CLEAR_ORG_ADMIN_DOCUMENT',
  GET_SUB_ORG_ASSETS_REQUEST: 'settings/GET_SUB_ORG_ASSETS_REQUEST',
  GET_SUB_ORG_ASSETS_SUCCESS: 'settings/GET_SUB_ORG_ASSETS_SUCCESS',
  GET_SUB_ORG_ASSETS_ERROR: 'settings/GET_SUB_ORG_ASSETS_ERROR',
  CREATE_SUB_ORG_ASSETS_REQUEST: 'settings/CREATE_SUB_ORG_ASSETS_REQUEST',
  CREATE_SUB_ORG_ASSETS_SUCCESS: 'settings/CREATE_SUB_ORG_ASSETS_SUCCESS',
  CREATE_SUB_ORG_ASSETS_ERROR: 'settings/CREATE_SUB_ORG_ASSETS_ERROR',
  DELETE_SUB_ORG_ASSETS_REQUEST: 'settings/DELETE_SUB_ORG_ASSETS_REQUEST',
  DELETE_SUB_ORG_ASSETS_SUCCESS: 'settings/DELETE_SUB_ORG_ASSETS_SUCCESS',
  DELETE_SUB_ORG_ASSETS_ERROR: 'settings/DELETE_SUB_ORG_ASSETS_ERROR',
  EDIT_SUB_ORG_ASSETS_REQUEST: 'settings/EDIT_SUB_ORG_ASSETS_REQUEST',
  EDIT_SUB_ORG_ASSETS_SUCCESS: 'settings/EDIT_SUB_ORG_ASSETS_SUCCESS',
  EDIT_SUB_ORG_ASSETS_ERROR: 'settings/EDIT_SUB_ORG_ASSETS_ERROR',
};

export const getOrganizationAdminDetails = (options, shouldSuppressErrorNotification = false) => async (dispatch) => {
  dispatch({ type: TYPES.GET_ORG_ADMIN_DETAILS_REQUEST });
  try {
    const data = await entity.api.getOrganizationAdminDetails(options);
    dispatch({ type: TYPES.GET_ORG_ADMIN_DETAILS_SUCCESS, payload: { [options?.organizationId]: data } });
  } catch (error) {
    dispatch({ type: TYPES.GET_ORG_ADMIN_DETAILS_ERROR, payload: error });
    if (!shouldSuppressErrorNotification) {
      if (!isEmpty(error.errors)) {
        dispatch(setNotification(`An error occurred while loading the organization admin details. ${error.errors[0]}`, VARIANTS.INFO));
      } else {
        dispatch(setNotification('An error occurred while loading the organization admin details.', VARIANTS.INFO));
      }
    }
    throw error;
  }
};

export const getOrgUrlParameters = organizationId => async (dispatch, getState) => {
  dispatch({ type: TYPES.GET_ORG_ADMIN_DETAILS_REQUEST });
  const profileKey = getProfileKey(getState());
  try {
    const response = await JobsAPI().getOrgUrlParameters(organizationId, profileKey);
    const payload = response;
    dispatch({ type: TYPES.GET_ORG_ADMIN_DETAILS_SUCCESS, payload: { [organizationId]: { ...payload?.data } } });
  } catch (error) {
    dispatch({ type: TYPES.GET_ORG_ADMIN_DETAILS_ERROR, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while loading url parameters. ${error.errors[0]}`, VARIANTS.INFO));
    } else if (+(error?.error_code) !== 404) {
      // 404 is expected for response
      dispatch(setNotification('An error occurred while loading url parameters.', VARIANTS.INFO));
    }
  }
};

export const updateOrgUrlParameters = (organizationId, params) => async (dispatch, getState) => {
  dispatch({ type: TYPES.EDIT_ORG_ADMIN_DETAILS_REQUEST });
  const profileKey = getProfileKey(getState());
  try {
    await JobsAPI().updateOrgUrlParameters(organizationId, params, profileKey);
    dispatch({ type: TYPES.EDIT_ORG_ADMIN_DETAILS_SUCCESS, payload: { url_params: params } });
  } catch (error) {
    dispatch({ type: TYPES.EDIT_ORG_ADMIN_DETAILS_ERROR, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while updating url parameters. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while updating url parameters.', VARIANTS.INFO));
    }
  }
};

export const editOrganizationAdminDetails = (organizationId, options) => async (dispatch) => {
  dispatch({ type: TYPES.EDIT_ORG_ADMIN_DETAILS_REQUEST });
  try {
    const data = await entity.api.editOrganizationAdminDetails(organizationId, options);
    dispatch({ type: TYPES.EDIT_ORG_ADMIN_DETAILS_SUCCESS, payload: { [organizationId]: data } });
  } catch (error) {
    dispatch({ type: TYPES.EDIT_ORG_ADMIN_DETAILS_ERROR, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while updating the organization admin details. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while updating the organization admin details.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const editOrganizationDetails = (organizationId, options) => async (dispatch) => {
  dispatch({ type: TYPES.EDIT_ORG_DETAILS_REQUEST });
  try {
    const data = await entity.api.editOrganizationDetails(organizationId, options);
    await dispatch(loadEmployerAccount(organizationId));
    dispatch({ type: TYPES.EDIT_ORG_DETAILS_SUCCESS, payload: { [organizationId]: data } });
    return data;
  } catch (error) {
    dispatch({ type: TYPES.EDIT_ORG_DETAILS_ERROR, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while updating the organization details. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while updating the organization details.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const getOrganization = options => async (dispatch, getState) => {
  dispatch({ type: TYPES.GET_ORG_REQUEST });
  try {
    const profileKey = getProfileKey(getState());
    const response = await entity.api.getOrganization(options, profileKey);
    const data = response?.data || {};
    const organizationId = options?.organizationId;
    dispatch({ type: TYPES.GET_ORG_SUCCESS, payload: { [organizationId]: data } });
    if (organizationId) dispatch(setOrgAssociation({ [organizationId]: true }));
    return response;
  } catch (error) {
    const organizationId = options?.organizationId;
    dispatch({ type: TYPES.GET_ORG_FAILURE, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while loading the organization. ${error.errors[0]}`, VARIANTS.INFO));
      return {};
    } if (error.error_code === 400) {
      if (organizationId) dispatch(setOrgAssociation({ [organizationId]: false }));
      return null;
    } if (error.error_code === 403) {
      if (organizationId) dispatch(setOrgAssociation({ [organizationId]: true }));
      return {};
    }
    dispatch(setNotification('An error occurred while loading the organization.', VARIANTS.INFO));
    return {};
  }
};

export const getOrganizationAssetsDetail = (organizationId, query) => async (dispatch) => {
  dispatch({ type: TYPES.GET_ORG_ASSETS_DETAILS_REQUEST });
  try {
    let types = ['HIRING_EVENT', 'JOB', 'HUB'];
    if (query?.asset_type) {
      types = types.filter(type => type === query.asset_type);
    }
    const response = await Promise.allSettled(types.map(type => entity.api.getOrganizationAssetsDetails(organizationId, merge({
      asset_type: type,
      desc_sort: true,
      page_index: 1,
      page_size: 1,
      sort_field: 'createdAt',
    }, query))));

    let assets = {};
    response.forEach((({ status, value }) => {
      if (status === 'fulfilled') {
        const data = value?.content.reduce((result, entity) => ({ ...result, [entity.id]: entity }), {});
        assets = { ...assets, ...data };
      }
    }));
    dispatch({ type: TYPES.GET_ORG_ASSETS_DETAILS_SUCCESS, payload: assets });
  } catch (error) {
    dispatch({ type: TYPES.GET_ORG_ASSETS_DETAILS_ERROR, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while loading the organization assets details. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while loading the organization assets details.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const getSubOrganizationAssets = (organizationId, subOrganizationId, query) => async (dispatch) => {
  dispatch({ type: TYPES.GET_SUB_ORG_ASSETS_REQUEST });
  try {
    let types = ['HIRING_EVENT', 'JOB', 'HUB'];
    if (query?.asset_type) {
      types = types.filter(type => type === query.asset_type);
    }
    const response = await Promise.allSettled(types.map(type => entity.api.getSubOrganizationAssets(organizationId, subOrganizationId, merge({
      asset_type: type,
      desc_sort: true,
      page_index: 1,
      page_size: 1,
      sort_field: 'createdAt',
    }, query))));

    let assets = {};
    response.forEach((({ status, value }) => {
      if (status === 'fulfilled') {
        const data = value?.content.reduce((result, entity) => ({ ...result, [entity.id]: entity }), {});
        assets = { ...assets, ...data };
      }
    }));
    dispatch({ type: TYPES.GET_SUB_ORG_ASSETS_SUCCESS, payload: assets });
  } catch (error) {
    dispatch({ type: TYPES.GET_SUB_ORG_ASSETS_ERROR, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while loading the sub organization assets. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while loading the sub organization assets.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const createOrganizationAssets = (organizationId, data) => async (dispatch) => {
  dispatch({ type: TYPES.CREATE_ORG_ASSETS_REQUEST });
  try {
    const response = await entity.api.createOrganizationAssets(organizationId, data);
    dispatch({ type: TYPES.CREATE_ORG_ASSETS_SUCCESS, payload: { [response.id]: response } });
  } catch (error) {
    dispatch({ type: TYPES.CREATE_ORG_ASSETS_ERROR, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while creating the organization assets. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while creating the organization assets.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const createSubOrganizationAssets = (organizationId, subOrganizationId, data) => async (dispatch) => {
  dispatch({ type: TYPES.CREATE_SUB_ORG_ASSETS_REQUEST });
  try {
    const response = await entity.api.createSubOrganizationAssets(organizationId, subOrganizationId, data);
    dispatch({ type: TYPES.CREATE_SUB_ORG_ASSETS_SUCCESS, payload: { [response.id]: response } });
  } catch (error) {
    dispatch({ type: TYPES.CREATE_SUB_ORG_ASSETS_ERROR, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while creating the sub organization assets. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while creating the sub organization assets.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const editOrganizationAssets = (organizationId, assetId, data) => async (dispatch) => {
  dispatch({ type: TYPES.EDIT_ORG_ASSETS_REQUEST });
  try {
    const response = await entity.api.editOrganizationAssets(organizationId, assetId, data);
    dispatch({ type: TYPES.EDIT_ORG_ASSETS_SUCCESS, payload: { [response.id]: response } });
  } catch (error) {
    dispatch({ type: TYPES.EDIT_ORG_ASSETS_ERROR, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while updating the organization assets. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while updating the organization assets.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const editSubOrganizationAssets = (organizationId, subOrganizationId, assetId, data) => async (dispatch) => {
  dispatch({ type: TYPES.EDIT_SUB_ORG_ASSETS_REQUEST });
  try {
    const response = await entity.api.editSubOrganizationAssets(organizationId, subOrganizationId, assetId, data);
    dispatch({ type: TYPES.EDIT_SUB_ORG_ASSETS_SUCCESS, payload: { [response.id]: response } });
  } catch (error) {
    dispatch({ type: TYPES.EDIT_SUB_ORG_ASSETS_ERROR, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while updating the sub organization assets. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while updating the sub organization assets.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const deleteOrganizationAssets = (organizationId, assetId) => async (dispatch) => {
  dispatch({ type: TYPES.DELETE_ORG_ASSETS_REQUEST });
  try {
    await entity.api.deleteOrganizationAssets(organizationId, assetId);
    dispatch({ type: TYPES.DELETE_ORG_ASSETS_SUCCESS });
  } catch (error) {
    dispatch({ type: TYPES.DELETE_ORG_ASSETS_ERROR, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while deleting the organization assets. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while deleting the organization assets.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const deleteSubOrganizationAssets = (organizationId, subOrganizationId, assetId) => async (dispatch) => {
  dispatch({ type: TYPES.DELETE_SUB_ORG_ASSETS_REQUEST });
  try {
    await entity.api.deleteSubOrganizationAssets(organizationId, subOrganizationId, assetId);
    dispatch({ type: TYPES.DELETE_SUB_ORG_ASSETS_SUCCESS });
  } catch (error) {
    dispatch({ type: TYPES.DELETE_SUB_ORG_ASSETS_ERROR, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while deleting the sub organization assets. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while deleting the sub organization assets.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const getOrganizationAdminDocument = organizationId => async (dispatch) => {
  dispatch({ type: TYPES.GET_ORG_ADMIN_DOCUMENT_REQUEST });
  try {
    const response = await entity.api.getOrganizationAdminDocument(organizationId);
    dispatch({ type: TYPES.GET_ORG_ADMIN_DOCUMENT_SUCCESS, payload: { documentData: response } });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.GET_ORG_ADMIN_DOCUMENT_ERROR, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while loading the organization admin document. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while loading the organization admin document.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const downloadOrganizationAdminDocument = (organizationId, options) => async (dispatch) => {
  dispatch({ type: TYPES.GET_ORG_ADMIN_DOCUMENT_REQUEST });
  try {
    const response = await entity.api.downloadOrganizationAdminDocument({ organizationId, ...options });
    const type = options?.isPdf ? 'application/pdf' : 'image/png';
    const myBlob = await response.blob();
    const url = URL.createObjectURL(new Blob([myBlob], { type }));
    const newFiles = { isPdf: options?.isPdf, [options.disposition]: url };
    dispatch({ type: TYPES.GET_ORG_ADMIN_DOCUMENT_SUCCESS, payload: { documentFiles: newFiles } });
  } catch (error) {
    dispatch({ type: TYPES.GET_ORG_ADMIN_DOCUMENT_ERROR, payload: error });
    if (!isEmpty(error.errors)) {
      dispatch(setNotification(`An error occurred while loading the organization admin document. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while loading the organization admin document.', VARIANTS.INFO));
    }
    throw error;
  }
};

export const clearDocument = async (dispatch) => {
  dispatch({ type: TYPES.CLEAR_ORG_ADMIN_DOCUMENT });
};

export default {
  TYPES,
  getOrganizationAdminDetails,
  editOrganizationDetails,
  editOrganizationAdminDetails,
  getOrganization,
  getOrganizationAdminDocument,
  updateOrgUrlParameters,
  getOrgUrlParameters,
  clearDocument,
  getOrganizationAssetsDetail,
  editOrganizationAssets,
  getSubOrganizationAssets,
  createOrganizationAssets,
  createSubOrganizationAssets,
  editSubOrganizationAssets,
  deleteOrganizationAssets,
  deleteSubOrganizationAssets,
};
